import { Image, useMediaQuery } from '@chakra-ui/react'
const quilmesImages = require.context('../assets/images', true)

const SessionStartLogo = () => {
  const [isLargerThan768] = useMediaQuery('(min-width: 780px)')

  return (
    <Image
      alt='logo'
      height='100%'
      src={quilmesImages('./logo.svg')}
      {...(isLargerThan768 ? { width: '30%' } : { width: '40%' })}
    />
  )
}

export default SessionStartLogo
